import backgroundImage from '../assets/office-background.png';

export function LoadingOverlay({ isVisible }) {
  if (!isVisible) return null;

  return (
    <div className="loading-overlay">
      <div className="background-image">
        <img
          src={backgroundImage}
          alt="Office background"
          className="background-img"
        />
      </div>
      
      <div className="dark-overlay"></div>
      
      <div className="loading-content">
        <h2 className="loading-text">
          Please wait, we're creating your boardroom.
        </h2>
      </div>
    </div>
  );
}